export default __webpack_public_path__ + "static/media/cable.0dff8e21.jpg";